import PropTypes from 'prop-types';
import React from "react";
import styles from "./Styles.module.scss";
import { Link } from "react-router";

class PrivacyView extends React.Component {
  render() {
    return <div className={styles.content}>
        <h2><u>PRIVACY POLICY</u></h2>
        <p>&nbsp;</p>
        <h6>Last Updated: 23 May 2025</h6>
        <p>&nbsp;</p>
        <p>
          Paperflite enables the visitors of its site <a href="http://www.paperflite.com">
            www.paperflite.com
          </a>, to be in control of their personal data. We also provide necessary controls that allow Paperflite’s users/customers to have control over the privacy of personal data that is captured by our service.
        </p>
        <p>
          The new European Union’s General Data Protection Regulation (GDPR)
          is a new piece of legislation that has impact on anyone whose
          business involves handling personal data about EU residents or
          within the EU. At Paperflite, we have leveraged this opportunity
          to establish a data protection standard across our operations
          globally.
        </p>
        <p>
          Paperflite considers data protection and privacy to be of
          paramount importance. We DO NOT sell your personal data and all
          processing operations are in strict compliance with applicable
          laws.
        </p>
        <p>
          This Privacy Policy explains how information about you is collected, used and disclosed by Paperflite, Inc. (hereinafter &quot;<strong
          >
            Paperflite
          </strong>&quot;, &quot;<strong>us</strong>&quot;, &quot;<strong>
            we
          </strong>&quot;, &quot;<strong>our</strong>&quot;, or any similar expression).
        </p>
        <p>
          If you are visitor of a site which is running services provided by
          Paperflite the ‘FliteView’ section of this Privacy policy will be
          of particular interest.
        </p>
        <p>
          For the purpose of this Privacy Policy, personal data means any
          information relating to an identified or identifiable natural
          person; an identifiable natural person is one who can be
          identified, directly or indirectly, in particular by reference to
          an identifier such as a name, an identification number, location
          data, an online identifier or to one or more factors specific to
          the physical, physiological, genetic, mental, economic, cultural
          or social identity of that natural person (the &quot;Personal
          Data&quot;).
        </p>
        <p>
          This Privacy Policy applies to information we collect when you use our website (<a href="http://www.paperflite.com">
            www.paperflite.com
          </a>) and/or other online products, applications and services offered/connected through our website (collectively, the &quot;Services&quot;).
        </p>
        <p>
          We are detailing out this Privacy Policy to provide you with
          information as applicable under sections 13 and 14 GDPR. However,
          you need to bear in mind that as a provider of the Paperflite
          Service, we act in the capacity of a Data Processor and any
          Privacy Policy of the Paperflite Customer (“Customer Privacy
          Policy&quot;) shall have priority over this Privacy Policy. This
          policy under no way should be construed as Paperflite taking up a
          role as Controller. The publication of the Customer Privacy Policy
          (or absence thereof) does not occur under the responsibility of
          Paperflite. Where ever you have already accepted a Customer
          Privacy Policy which applies to your use of Paperflite Customer
          instance (“FliteView”) on the Paperflite or where such Customer
          Privacy Policy becomes applicable to your interaction therewith,
          the Customer Privacy Policy shall apply and have priority.
        </p>
        <h4>Information Collection &amp; Usage:</h4>
        <p>
          <strong>User Provided Information</strong>&nbsp;
        </p>
        <p>
          We collect the information you provide when you download and
          register for one of the services. Registration with us is
          optional. However, please keep in mind that you may not be able to
          use some of the features offered unless you register with us.
        </p>
        <p>
          When you register with us and use the Application, you generally
          provide (a) your name, email, user name, password &amp; other
          registration information; (b) transaction-related information,
          such as when you make purchases, respond to any offers, or
          download or use applications from us; (c) information you provide
          us when you contact us for help; &amp; (d) information you enter
          into our system when using the services, such as contact
          information &amp; project management information. Any payments you
          may make for the Services will be received and processed through
          our third party payment provider, so we do not collect or store
          your payment information.
        </p>
        <p>
          <strong>Integrated Services</strong>
        </p>
        <p>
          You may be given the option to access or register for the Service
          through the use of your user name &amp; passwords for certain
          services provided by third parties (each, an &quot;Integrated
          Service&quot;), such as through the use of your Google account, or
          otherwise have the option to authorize an Integrated Service to
          provide Personal Data or other information to us. By authorizing
          us to connect with an Integrated Service, you authorize us to
          access and store your name, email address(es), current city,
          profile picture URL, and other information that the Integrated
          Service makes available to us, and to use and disclose it in
          accordance with this Policy. You should check your privacy
          settings on each Integrated Service to understand what information
          that Integrated Service makes available to us, and make changes as
          appropriate. Please review each Integrated Service&#39;s terms of
          use and privacy policies carefully before using their services and
          connecting to our Service.
        </p>
        <p>
          <strong>Automatically Collected Information</strong>&nbsp;
        </p>
        <p>
          In addition, the Application may collect certain information
          automatically, including, but not limited to, the type of mobile
          device you use, your mobile devices unique device ID, the IP
          address of your mobile device, your mobile operating system, the
          type of mobile Internet browsers you use, and information about
          the way you use the Application.  Also, we use various
          technologies to collect information, and this may include cookies
          in your computer or mobile device. Cookies are small data files
          stored on your hard drive or in device memory that helps us to
          improve our Services and your experience, see which areas and
          features of our Services are popular and count visits. More
          details listed under section titled &quot;COOKIES&quot;.
        </p>
        <p>&nbsp;</p>
        <strong>
          Do we collect precise real time location information of the
          device?
        </strong>
        <p>
          No, we do not collect precise information about the location of
          your mobile device.&nbsp;
        </p>
        <p>&nbsp;</p>
        <p>
          <strong>
            Do third parties see and/or have access to information obtained
            by the Application?
          </strong>
        </p>
        <p>
          We will share your information with third parties only in the ways
          that are described in this privacy statement. We do not share,
          sell, rent, or trade personal data with third parties for their
          promotional purposes
        </p>
        <p>
          We may disclose User Provided and Automatically Collected
          Information:
        </p>
        <ul>
          <li>
            as required by law, such as to comply with a subpoena, or
            similar legal process;
          </li>
          <li>
            when we believe in good faith that disclosure is necessary to
            protect our rights, protect your safety or the safety of others,
            investigate fraud, or respond to a government request;
          </li>
          <li>
            with our trusted services providers who work on our behalf, do
            not have an independent use of the information we disclose to
            them, and have agreed to adhere to the rules set forth in this
            privacy statement.
          </li>
          <li>
            if Paperflite is involved in a merger, acquisition, or sale of
            all or a portion of its assets, you will be notified via email
            and/or a prominent notice on our Website of any change in
            ownership or uses of this information, as well as any choices
            you may have regarding this information.
          </li>
          <li>
            Your information may be stored in servers with locations in a
            different geography from yours in order to provide the best of
            aforementioned services at all times where privacy laws maybe
            different than your home state and thus outside your
            jurisdiction.
          </li>
        </ul>
        <h4>COOKIE POLICY:</h4>
        <p>
          When visiting the Website or when You are making use of the
          Paperflite applications, a Cookie or similar technology, may be
          placed on Your end device or used during Your use of the Website,
          Application of related items (e.g. emails).
        </p>
        <p>
          A cookie is a tiny data file which is stored on Your end device
          (&quot;Cookie&quot;). A Cookie enables certain features and
          functionalities of the Website or Applications. A cookie does not
          contain or collect information in isolation, but when read by a
          server via Your web browser or through the Applications, it can
          provide information to such server to facilitate a more
          user-friendly service by registering, among other data, users’
          preferences, detect errors, account information, device
          identification and/or collect data for statistics.
        </p>
        <p>
          When You disable one or more cookies, you will probably still be
          able to browse the Website and use the Applications, however
          certain features may not work as expected or may be deactivated as
          a result therefrom. We allow third parties with which we have a
          separate agreement to use cookies and other technologies to
          collect information about your use of the Site. These third
          parties include (1) business partners, which collect information
          when you view or interact with one of their advertisements on the
          Site; and (2) advertising networks, which collect information
          about your interests when you view or interact with one of their
          advertisements.
        </p>
        <p>
          The information gathered by these third parties is used to make
          predictions about your interests or preferences so that they can
          display advertisements or promotional material on this Site and on
          other sites across the Internet tailored to your apparent
          interests.
        </p>
        <p>
          The business partners and advertising networks that serve
          interest-based advertisements on the Services have limited access
          to a small amount of information about your profile and your
          device, which is necessary to serve you advertisements that are
          tailored to your apparent interests. It is possible that they may
          reuse this small amount of information on other sites or services.
        </p>
        <p>
          We do not share with these third parties any information that
          would readily identify you (such as email address); however, these
          third parties may have access to information about your device
          (such as IP or MAC address). We do not have access to, or control
          over, the technologies that these third parties may use to collect
          information about your interests, and the informationpractices of
          these third parties are not covered by this Privacy Notice. Other
          than as discussed in this document, we have no control over these
          third parties.
        </p>
        <h4>The Following Types of Cookies Are Used in the Site:</h4>
        <p>
          <strong>Strictly necessary/essential cookies -</strong> These cookies are essential in order to enable you to move around the website and use its features, such as accessing secure areas of the website. Without these cookies services you have asked for cannot be provided. These cookies don’t collect information that identifies a visitor.
        </p>
        <p>
          <strong>Performance cookies -</strong> These cookies collect information about how visitors use a website, for instance which pages visitors go to most often, and if they get error messages from web pages. These cookies don’t collect information that identifies a visitor. All information these cookies collect is aggregated and therefore anonymous. It is only used to improve how a website works.
        </p>
        <p>
          <strong>Functionality cookies -</strong> These cookies allow the website to remember choices you make (such as your user name, language or the region you are in) and provide enhanced, more personal features. For instance, a website may be able to provide you with local weather reports or traffic news by storing in a cookie the region in which you are currently located. These cookies can also be used to remember changes you have made to text size, fonts and other parts of web pages that you can customise. They may also be used to provide services you have asked for such as watching a video or commenting on a blog. The information these cookies collect may be anonymised and they cannot track your browsing activity on other websites.
        </p>
        <p>
          <strong>Behaviourally targeted advertising cookies -</strong> These cookies are used to deliver adverts more relevant to you and your interests They are also used to limit the number of times you see an advertisement as well as help measure the effectiveness of the advertising campaigns. They are usually placed by advertising networks with the website operator’s permission. They remember that you have visited a website and this information is shared with other organisations such as advertisers. Quite often targeting or advertising cookies will be linked to site functionality provided by the other organisation.
        </p>
        <h4>The Following Cookies are Used in the Site:</h4>
        <table> 
          <tr>
            <th>Service provider</th>
            <th>Cookie name</th>
            <th>Cookie type</th>
            <th>Expiration</th>
            <th>Content</th>
          </tr>
          <tr>
            <td>Facebook</td>
            <td>fr</td>
            <td>Advertising and Measurement</td>
            <td>90 days</td>
            <td>
              User and browser ID; time stamp; miscellaneous other data
            </td>
          </tr>
          <tr>
            <td>Facebook</td>
            <td>oo</td>
            <td>Advertising and Measurement</td>
            <td>5 years</td>
            <td>1 or 0</td>
          </tr>
          <tr>
            <td>Facebook</td>
            <td>ddid</td>
            <td>Advertising and Measurement</td>
            <td>28 days</td>
            <td>Object ID and App ID</td>
          </tr>
          <tr>
            <td>Google</td>
            <td>_ga</td>
            <td>Analytics</td>
            <td>2 years</td>
            <td>Used to distinguish users.</td>
          </tr>
          <tr>
            <td>Google</td>
            <td>_gid</td>
            <td>Analytics</td>
            <td>24 hours</td>
            <td>Used to distinguish users.</td>
          </tr>
          <tr>
            <td>Google</td>
            <td>_gat</td>
            <td>Analytics</td>
            <td>1 minute</td>
            <td>
              Used to throttle request rate. If Google Analytics is deployed
              via Google Tag Manager, this cookie will be named
              _dc_gtm_&lt;property-id&gt;
            </td>
          </tr>
          <tr>
            <td>Google</td>
            <td>AMP_TOKEN</td>
            <td>Analytics</td>
            <td>30 seconds to 1 year</td>
            <td>
              Contains a token that can be used to retrieve a Client ID from
              AMP Client ID service. Other possible values indicate opt-out,
              inflight request or an error retrieving a Client ID from AMP
              Client ID service.
            </td>
          </tr>
          <tr>
            <td>Google</td>
            <td>_gac_&lt;property-id&gt;</td>
            <td>Analytics</td>
            <td>90 days</td>
            <td>
              Contains campaign related information for the user. If you have linked your Google Analytics and AdWords accounts, AdWords website conversion tags will read this cookie unless you opt-out. <a href="https://support.google.com/adwords/answer/7521212">
                Learn more
              </a>.
            </td>
          </tr>
          <tr>
            <td>Google</td>
            <td>__utma</td>
            <td>Analytics</td>
            <td>2 years from set/update</td>
            <td>
              Used to distinguish users and sessions. The cookie is created
              when the javascript library executes and no existing __utma
              cookies exists. The cookie is updated every time data is sent
              to Google Analytics.
            </td>
          </tr>
          <tr>
            <td>Google</td>
            <td>__utmt</td>
            <td>Analytics</td>
            <td>10 minutes</td>
            <td>Used to throttle request rate.</td>
          </tr>
          <tr>
            <td>Google</td>
            <td>__utmb</td>
            <td>Analytics</td>
            <td>30 mins from set/update</td>
            <td>
              Used to determine new sessions/visits. The cookie is created
              when the javascript library executes and no existing __utmb
              cookies exists. The cookie is updated every time data is sent
              to Google Analytics.
            </td>
          </tr>
          <tr>
            <td>Google</td>
            <td>__utmc</td>
            <td>Analytics</td>
            <td>End of browser session</td>
            <td>
              Not used in ga.js. Set for interoperability with urchin.js.
              Historically, this cookie operated in conjunction with the
              __utmb cookie to determine whether the user was in a new
              session/visit.
            </td>
          </tr>
          <tr>
            <td>Google</td>
            <td>__utmz</td>
            <td>Analytics</td>
            <td>6 months from set/update</td>
            <td>
              Not used in ga.js. Set for interoperability with urchin.js.
              Historically, this cookie operated in conjunction with the
              __utmb cookie to determine whether the user was in a new
              session/visit.
            </td>
          </tr>
          <tr>
            <td>Google</td>
            <td>__utmv</td>
            <td>Analytics</td>
            <td>2 years from set/update</td>
            <td>Used to store visitor-level custom variable data.</td>
          </tr>
          <tr>
            <td>Google</td>
            <td>__utmx</td>
            <td>Content Experiments</td>
            <td>18 months</td>
            <td>Used to determine a user's inclusion in an experiment.</td>
          </tr>
          <tr>
            <td>Google</td>
            <td>__utmxx</td>
            <td>Content Experiments</td>
            <td>18 months</td>
            <td>
              Used to determine the expiry of experiments a user has been
              included in.
            </td>
          </tr>
          <tr>
            <td>Google</td>
            <td>_gaexp</td>
            <td>Optimize 360</td>
            <td>
              Depends on the length of the experiment but typically 90 days.
            </td>
            <td>
              Used to determine a user's inclusion in an experiment and the
              expiry of experiments a user has been included in.
            </td>
          </tr>
          <tr>
            <td>Hotjar</td>
            <td>_hjClosedSurveyInvites</td>
            <td>Analytics</td>
            <td>365 days</td>
            <td>
              This cookie is set once a visitor interacts with a Survey
              invitation modal popup. It is used to ensure that the same
              invite does not re-appear if it has already been shown.
            </td>
          </tr>
          <tr>
            <td>Hotjar</td>
            <td>_hjDonePolls</td>
            <td>Analytics</td>
            <td>365 days</td>
            <td>
              This cookie is set once a visitor completes a poll using the
              Feedback Poll widget. It is used to ensure that the same poll
              does not re-appear if it has already been filled in.
            </td>
          </tr>
          <tr>
            <td>Hotjar</td>
            <td>_hjMinimizedPolls</td>
            <td>Analytics</td>
            <td>365 days</td>
            <td>
              This cookie is set once a visitor minimizes a Feedback Poll
              widget. It is used to ensure that the widget stays minimizes
              when the visitor navigates through your site.
            </td>
          </tr>
          <tr>
            <td>Hotjar</td>
            <td>_hjDoneTestersWidgets</td>
            <td>Analytics</td>
            <td>365 days</td>
            <td>
              This cookie is set once a visitor submits their information in
              the Recruit User Testers widget. It is used to ensure that the
              same form does not re-appear if it has already been filled in.
            </td>
          </tr>
          <tr>
            <td>Hotjar</td>
            <td>_hjMinimizedTestersWidgets</td>
            <td>Analytics</td>
            <td>365 days</td>
            <td>
              This cookie is set once a visitor minimizes a Recruit User
              Testers widget. It is used to ensure that the widget stays
              minimizes when the visitor navigates through your site.
            </td>
          </tr>
          <tr>
            <td>Hotjar</td>
            <td>_hjIncludedInSample</td>
            <td>Analytics</td>
            <td>365 days</td>
            <td>
              This session cookie is set to let Hotjar know whether that
              visitor is included in the sample which is used to generate
              funnels.
            </td>
          </tr>
        </table>
        <br/>
        <p>
          <strong>Analytics Services Provided by Other Companies</strong>
        </p>
        <p>
          We may allow others to provide us with analytics services. These
          entities may use cookies, web beacons and other technologies to
          collect information about your use of the Services, including your
          IP address, web browser, pages viewed, time spent on pages, links
          clicked and other usage information. This information may be used
          by Paperflite to, among other things, analyze and track data,
          determine the popularity of certain content and better understand
          your usage of the Services.
        </p>
        <p>
          <strong>FliteView</strong>
        </p>
        <p>
          Our customers should they decide to share select content through
          the signature webpage ‘FliteView’ service made available to
          you, we collect certain data to be provided to our customers who
          had subscribed to Paperflite related to the application usage so
          they can offer you a better service and or to study the user
          behavior to enhance your experience with the application.
        </p>
        <p>
          The type of data collected includes your email as entered when
          providing you with the exclusive access, time spent on the content
          that was shared with you and who you forward to understand how the
          content effectiveness, email address of recipients that you decide
          to share the webpage with.  As with our strict adherence to your
          data, we do not share this information with any third party for
          promotional purposes.
        </p>
        <p>
          <strong>
            Is Paperflite a Data Processor or Data Controller?
          </strong>
        </p>
        <p>
          Paperflite customers decide which specific individuals to share
          their content with through Paperflite Service and as result whose
          personal data gets processed. As defined by GDPR, therefore, it is
          the Paperflite Customer who is legally acting as the Data
          Controller.
        </p>
        <p>
          In this situation Paperflite is only offering the means allowing
          the Paperflite Customer to interact with their respective Users
          and Prospects through the Paperflite Service. This means that
          Paperflite is only processing the personal data for and on behalf
          of the Paperflite Customer as a &quot;Processor&quot; (as defined
          under GDPR).
        </p>
        <p>
          <h4>Data Transfer</h4>
        </p>
        <p>
          We are concerned about safeguarding the confidentiality of your
          information. We employ reasonable measures as per the industry
          standards designed to protect this information from unauthorized
          access. All measures to comply with section 32 GDPR which includes
          (i) protection against unauthorised disclosures, ii) ensuring
          integrity, availability and resilience of the processing systems,
          and iii) maintaining the ability to restore the availability and
          access to the Personal Data being processed in a timely manner in
          the event of a physical or technical incident is a part of the
          process.
        </p>
        
        <p>
          <strong>What are my opt-out rights?</strong>
        </p>
        <p>
          You can review, update, correct or delete the personal data provided in your registration or account profile by changing your &quot;account settings&quot;. Alternatively, you can stop all collection of information by the Application easily by uninstalling the Application. You may use the standard uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or network. You can also request to opt-out via email, at <a href="mailto:support@paperflite.com">support@paperflite.com</a>
        </p>
        
        <p>
          <strong>Minors and Children’s Privacy</strong>
        </p>
        <p>
          We do not use the Application to knowingly solicit data from or market to children under the age of 13. If a parent or guardian becomes aware that his or her child has provided us with information without their consent, he or she should contact us at <a href="mailto:support@paperflite.com">
            support@paperflite.com
          </a>. We will delete such information from our files within a reasonable time.
        </p>
        
        <h4>
          <strong>Changes and Updates to this Policy</strong>
        </h4>
        <p>
          This Privacy Policy may be updated from time to time for any
          reason. We will notify you of any changes to our Privacy Policy by
          posting the new Privacy Policy here and informing you via email or
          text message. You are advised to consult this Privacy Policy
          regularly for any changes, as continued use is deemed approval of
          all changes.
        </p>
        
        <p>
          <strong>Your Consent</strong>
        </p>
        <p>
          By using the Application, you are consenting to our processing of
          your information as set forth in this Privacy Policy now and as
          amended by us. &quot;Processing,&quot; means using cookies on a
          computer/hand held device or using or touching information in any
          way, including, but not limited to, collecting, storing, deleting,
          using, combining and disclosing information, all of which
          activities will take place in the United States. If you reside
          outside the United States your information will be transferred,
          processed and stored there under United States privacy standards.
        </p>
        <p>
          <strong>How to Contact Us</strong>
        </p>
        <p>
          If you have any questions or comments regarding this policy, your personal data, our use and disclosure practices or your consent choices by email at <a href="mailto:support@paperflite.com">
            support@paperflite.com
          </a>. If you have any concerns or complaints about this Policy or your Personal Data, you may contact Paperflite/s Data Protection Officer by email at
          <a href="mailto:dpo@paperflite.com"> dpo@paperflite.com</a>
        </p>
      </div>;
  }
}

export default PrivacyView;
